import React, { useState } from 'react';
import CurrencyInput from './CurrencyInput';

const UNITS = [
  { value: 'percentage', label: '%' },
  { value: 'currency', label: '₪' }
];

const segmentStyle = active => ({
  boxSizing: 'border-box',
  width: 20,
  height: 20,
  margin: 0,
  padding: 2,
  border: 0,
  borderRadius: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 10,
  lineHeight: 1,
  background: active ? '#237ff3' : 'transparent',
  color: active ? '#fff' : '#555',
  fontWeight: 600,
  cursor: 'pointer',
  flex: '0 0 20px'
});

const CurrencyPercentToggleInput = ({
  value,
  percentValue,
  onChange,
  onChangePercent,
  disabled = false,
  className = ''
}) => {
  const [mode, setMode] = useState('currency');
  const isPercent = mode === 'percentage';

  return (
    <div
      dir="ltr"
      className={`currency-percent-toggle d-flex align-items-center border rounded bg-white ${
        disabled ? 'opacity-50' : ''
      } ${className}`}
      style={{ height: 31, padding: '0 4px', gap: 4 }}
    >
      <div
        className="d-flex flex-shrink-0 overflow-hidden"
        style={{
          width: 40,
          height: 20,
          borderRadius: 4,
          border: '1px solid #cfd6dd',
          background: '#eef0f3'
        }}
      >
        {UNITS.map(unit => {
          const active = mode === unit.value;
          return (
            <button
              key={unit.value}
              type="button"
              disabled={disabled}
              onClick={() => setMode(unit.value)}
              style={{
                ...segmentStyle(active),
                cursor: disabled ? 'not-allowed' : 'pointer'
              }}
            >
              {unit.label}
            </button>
          );
        })}
      </div>

      <CurrencyInput
        className="m-0 border-0 shadow-none flex-grow-1 text-end"
        style={{ minWidth: 0, height: 28, padding: 0, background: 'transparent', fontSize: 13 }}
        size="sm"
        disabled={disabled}
        value={isPercent ? percentValue : value}
        onChange={isPercent ? onChangePercent : onChange}
        maxDecimal={isPercent ? 2 : 0}
      />
    </div>
  );
};

export default CurrencyPercentToggleInput;
